export default __webpack_public_path__ + "static/media/pr_c_01.8b06a7f8.jpg";